import { openBlock as o, createElementBlock as t, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(s, e) {
  return o(), t("svg", r, [...e[0] || (e[0] = [
    n("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      d: "M18.5 5 5 18.5m0 0h9.5m-9.5 0V9"
    }, null, -1)
  ])]);
}
const d = { render: l };
export {
  d as default,
  l as render
};
